import React from "react";
import downloadIcon from "../../Resources/Image/sd-download.svg";
import {useDispatch} from "react-redux";
import {getStoreExtendedReport} from "../../Actions/monthlyStoreExtendedReportAction";
import {getCSVDownload} from "../../Util/TableHelpers/storeUsageHelper";

const StoreUsageCSVDownloader = ({date, accountDetails}) => {
    const dispatch = useDispatch();
    const handleClick = () => {
        dispatch(getStoreExtendedReport(date, accountDetails.companyId, (data) => {
            let csvContent = "data:text/csv;charset=utf-8," + getCSVDownload(data);
            let encodedURI = encodeURI(csvContent)
            let link = document.createElement("a");
            link.setAttribute("href", encodedURI);
            link.setAttribute("download", accountDetails.companyName + "_" + date + ".csv");
            document.body.appendChild(link); // Required for FF

            link.click();
            link.remove();
        }))
    }

    return (
        <div onClick={handleClick} className="downloadBtn" title={"Download Store Order Details"}><img
            src={downloadIcon}/></div>
    );
}

export default StoreUsageCSVDownloader;
